import { Box, Button, Flex } from "@chakra-ui/react";
import { Modal } from "@reconvert/react-ui-component";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAppState, toggleHelpModal } from "../../app/slice/appSlice";
import { useDirection } from "../../hooks/useDirection";
import ReviewCollectorModalV2 from "../ReviewCollector/ReviewCollectorModalV2";
import { BookDemoBanner } from "../BookDemoBanner";
import { APP_PLATFORM } from "../../config";
import { Platform } from "../../models";
import { updateShopInfoThunk, updateShopInfoLocal } from "../../app/slice/shopinfoSlice";

const HelpModal = () => {
  const { t } = useTranslation();
  const { showHelpModal, helpArticleLink, helpArticleTitle } = useAppSelector(selectAppState);
  const dispatch = useAppDispatch();
  const { isRTL } = useDirection();

  if (!showHelpModal) return null;

  const onHelpModalClose = () => {
    dispatch(toggleHelpModal());
    dispatch(updateShopInfoLocal({
      show_help_video_modal: "1",
    }));
    dispatch(updateShopInfoThunk({
      show_help_video_modal: "1",
    }));
  };

  return (
    <Modal
      isOpen={showHelpModal}
      onClose={onHelpModalClose}
      closeOnEsc={true}
      title={helpArticleTitle ?? null}
      hideCloseButton={true}
      size="6xl"
      footer={
        <Flex
          margin="0 16px"
          justifyContent="space-between"
          alignItems="center"
          width="calc(100% - 64px)"
          minHeight="80px"
        >
          <Box />
          <Box display="flex" justifyContent="center">
            {APP_PLATFORM === Platform.Shopify && <ReviewCollectorModalV2 />}
          </Box>
          <Box display="flex" justifyContent="flex-end">
            <Button
              padding={'8px 16px'}
              variant={'secondary'}
              onClick={onHelpModalClose}
              style={{ ...(isRTL && { marginLeft: "16px" }) }}
            >
              {t('Close')}
            </Button>
          </Box>
        </Flex>
      }
    >
      {APP_PLATFORM === Platform.Shopify && <BookDemoBanner location="help_popup" marginBottom="24px" />}
      <iframe src={helpArticleLink} title={helpArticleTitle} style={{ width: "100%", height: "70vh" }} />
    </Modal>
  );
};

export default HelpModal;
